<template>
  <div class="profile-grid" style="margin:10px 0">
    <div class="labels">{{ label }}</div>
    <template v-if="editing">
      <div><input type="text" v-model="mvalue" class="widener" /></div>
      <div class="pf-edit-button" v-on:click="handleSave">save</div>
    </template>
    <template v-else>
      <div>{{ mvalue }}</div>
      <div class="pf-edit-button" v-on:click="editMode">edit</div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    label: String
  },
  data() {
    return {
      editing: false,
      mvalue: ''
    }
  },
  created() {
    if(this.value){
      this.mvalue = this.value
    }
  },
  methods: {
    editMode() {
      this.editing = true
    },
    handleSave() {
      this.editing = false
      this.$emit('input', this.mvalue)
    }
  },
  watch: {
    value() {
      this.mvalue = this.value
    }
  }
}
</script>
<style scoped>
.widener{
  width:100%;
}
</style>